<template>
  <el-drawer
    id="xzt_list"
    title="统计"
    :visible.sync="drawer"
    :direction="direction"
    :withHeader="false"
    :before-close="handleClose"
  >
    <div class="header">
      统计
    </div>
    <div class="content clearfix">
      <div class="content-item">
        <el-table
        ref="tableArr"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        :row-style="{ height: '0' }"
        :cell-style="changeCellStyle"
      >
        <template v-for="item in items">
          <el-table-column
            v-if="item.id == 'title'"
            header-align="center"
            align="center"
            :label="item.name"
            :prop="item.id"
          >
            <template slot-scope="scope">
              <div :class="`title ${scope.row.color}`">
                {{ scope.row.title }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-else
            :key="item.name"
            header-align="center"
            align="center"
            :label="item.name"
            :prop="item.id"
          ></el-table-column>
        </template>
       
      </el-table>
      </div>
      <div class="content-item">
        <el-table
        ref="tableArr"
        :data="wsData"
        tooltip-effect="dark"
        style="width: 100%"
        :row-style="{ height: '0' }"
        :cell-style="changeCellStyle"
      >
        <template v-for="item in items">
          <el-table-column
            v-if="item.id == 'title'"
            header-align="center"
            align="center"
            :label="item.name"
            :prop="item.id"
          >
            <template slot-scope="scope">
              <div :class="`title ${scope.row.color}`">
                {{ scope.row.title }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-else
            :key="item.name"
            header-align="center"
            align="center"
            :label="item.name"
            :prop="item.id"
          ></el-table-column>
        </template>
       
      </el-table>
      </div>
    </div>
  </el-drawer>
</template>
<script>
export default {
  data() {
    return {
      items: [
        { name: "名称", id: "name" },
        { name: "总金额", id: "value" },
      ],
      tableData: [],
      wsData: [],
      drawer: false,
      direction: "rtl",
      isshow: false,
    };
  },
  methods: {
    changeCellStyle(value) {
      //列的label的名称
      
      if(value.row.color == 1){
        return "color:black;font-weight:bold;font-size:20px;height:40px;padding:0;"; //修改的样式
      }else{
        return "color:red;font-weight:bold;font-size:20px;height:40px;padding:0;"; //修改的样式
      }
      
    },
    show(value,value1) {
      this.drawer = true;
      this.tableData = [];
      this.wsData = [];
      if (value !== undefined) {
        // this.tableData = value;
        let total0 = 0
        value.forEach((item,index)=>{
            total0 = total0 + item.value;
            this.tableData.push({
              name:item.name,value:item.value,color:1,
            });
        })

        this.tableData.push({
                  name:"总计",
                  value:total0,
                  color:2,
        })
      }
      if (value1 !== undefined) {
        // this.wsData = value1;
        let total1 = 0
        value1.forEach((item,index)=>{
            total1 = total1 + item.value;
            this.wsData.push({
              name:item.name,value:item.value,color:1,
            });
        })
        this.wsData.push({
                  name:"总计",
                  value:total1,
                  color:2,
        })
      }
    },
  },
};
</script>
<style lang="less" scope>
#xzt_list {
  font-size: 20px;
  color: black;
  /deep/.el-drawer {
    min-width: 500px;
  }
  .header {
    height: 40px;
    width: 100%;
    background-image: linear-gradient(to right, #0f6ad7, #00ced4);
    padding: 0 30px;
    box-sizing: border-box;
    color: white;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    line-height: 40px;
    p {
      display: inline-block;
      margin-left: 10px;
    }
  }

  .content {
    //   width: 1000px;
    //   margin: 0 auto;
    overflow-y: scroll;
    overflow-x: hidden;
    height: calc(100vh - 40px);
    /deep/.el-table .rowstyle {
      background: black;
    }
    .content-item{
      float: left;
      width:50%;
    }
    .title {
      font-size: 20px;
      font-weight: bold;
      &.red {
        color: rgb(245, 140, 140);
      }
      &.blue {
        color: rgb(118, 118, 242);
      }
      &.green {
        color: rgb(64, 209, 64);
      }
    }
  }
}
</style>